<!--
  대시보드 장비 토폴로지 위젯 팝업
  장비 상태 요약 정보

  @since: 2018-07-12
  @author: mk.ko
-->

<template>
  <layout-modal ref="deviceSumaryModal"
                class="bs bs-q-modal bs-q-modal-default"
                :confirmEvt="onConfirm"
                :cancelEvt="onCancel"
                :content-css="{minWidth: '900px', minHeight: '720px'}"
                :titleName="titleName"
                :footerBtn= "['cancel', 'confirm']"
                :is-open.sync="isOpen"
                @hide="hide">
    <!--class="bs bs-q-modal bs-q-modal-flat"-->

    <!-- Start: [상세 정보] 컨텐츠 시작 -->
    <div class="content-group">
      <div class="contents-row">
        <!-- 타이틀 시작 -->
        <div class="page-title-1depth">
          <span class="page-title-1depth-text">{{ $t('cmn.detailInfo') }}</span>
        </div>
        <!-- 타이틀 끝 -->
      </div>
      <div class="contents-row">

        <!-- 컨텐츠 패널 시작 -->
        <div class="portlet">

          <div class="row no-wrap">
            <div class="contents-row">
              <!-- 테이블 시작 -->
              <table class="bs-table  table-bordered">
                <colgroup>
                  <col width="30%"/>
                  <col width="auto"/>
                </colgroup>
                <tbody>

                  <tr>
                    <td class="td-head">{{ $t('sm.deviceConfig_deviceCompositionStatus_gridDeviceName') }}</td>
                    <td>{{detailDeviceInfo.device_uname}}</td>
                  </tr>

                  <tr>
                    <td class="td-head">{{ $t('cmn.model') }}</td>
                    <td>{{detailDeviceInfo.device_model_name}}</td>
                  </tr>

                  <tr>
                    <td class="td-head">{{ $t('cmn.ip') }}</td>
                    <td>
                      <template>
                        {{detailDeviceInfo.device_ip}}
                      </template>
                    </td>
                  </tr>

                  <!--<tr>-->
                    <!--<td class="td-head">{{ $t('dash.topology_licenseExpiredDate') }}</td>-->
                    <!--<td>{{detailDeviceInfo.device_license_end}}</td>-->
                  <!--</tr>-->

                  <!--<tr>-->
                    <!--<td class="td-head">{{ $t('cmn.runningTime') }}</td>-->
                    <!--<td>{{detailDeviceInfo.device_running_time}}</td>-->
                  <!--</tr>-->

                  <tr>
                    <td class="td-head">{{ $t('cmn.description') }}</td>
                    <td>{{detailDeviceInfo.device_desc}}</td>
                  </tr>

                </tbody>
              </table>
              <!-- 테이블 끝 -->
            </div>

            <div class="contents-row ps-dash-topologyRisk marLauto">
              <div>
                <span class="ps-dash-topologyRisk-label">{{ $t('cmn.nowTime') }} {{ $t('cmn.risk') }}</span>
                <div class="ps-icon-risk ps-icon-risk-critical" v-if="risk === 5"></div>
                <div class="ps-icon-risk ps-icon-risk-high" v-if="risk === 4"></div>
                <div class="ps-icon-risk ps-icon-risk-medium" v-if="risk === 3"></div>
                <div class="ps-icon-risk ps-icon-risk-low" v-if="risk === 2"></div>
                <div class="ps-icon-risk ps-icon-risk-info" v-if="risk === 1"></div>
              </div>
            </div>

          </div>

        </div>
        <!-- 컨텐츠 패널 끝 -->

      </div>
    </div>
    <!-- End: [상세 정보] 컨텐츠 끝 -->

    <!-- 컨텐츠 분할 시작 -->
    <div class="contents-clearfix"></div>
    <!-- 컨텐츠 분할 끝 -->

    <!-- Start: [계층 관계] 컨텐츠 시작 -->
    <div class="content-group">
      <div class="contents-row">
        <!-- 타이틀 시작 -->
        <div class="page-title-1depth">
          <span class="page-title-1depth-text">{{ $t('da.topology_hierarchyRelation') }}</span>
        </div>
        <!-- 타이틀 끝 -->
      </div>
      <div class="contents-row">
        <div class="device-hierarchy-scroll-area target-scroll portlet ps-dash-hierarchyBlock row items-center"
             style="width: 849px; height: 200px;">

            <ul class="ps-dash-hierarchyList row no-wrap">

              <!-- 상단 계층 별 노드 -->
              <li v-for="(item, idx) in node.hierarchy"
                  class="ps-dash-hierarchyList-item"
                  :style="calcHierarchyItemPadding(idx)"
              >
                <div class="ps-dash-hierarchyList-title">{{item.label}}</div>
                <div class="ps-dash-hierarchyList-icon"></div>
                <tool-tip :message="item.label"/>
              </li>

              <!-- 마지막 노드 -->
              <li :style="calcHierarchyItemPadding(void 0, true)"
                  class="ps-dash-hierarchyList-item">
                <div class="ps-dash-hierarchyList-title"><b>{{node.name}}</b></div>
                <div class="ps-dash-hierarchyList-icon"></div>
                <tool-tip :message="node.name"/>
              </li>

            </ul>
          <!-- 컨텐츠 패널 끝 -->
        </div>

      </div>
    </div>
    <!-- End: [계층 관계] 컨텐츠 끝 -->

    <!-- 컨텐츠 분할 시작 -->
    <div class="contents-clearfix"></div>
    <!-- 컨텐츠 분할 끝 -->

    <!-- Start: [이벤트 현황] 컨텐츠 시작 -->
    <div class="content-group">
      <div class="contents-row">
        <!-- 타이틀 시작 -->
        <div class="page-title-1depth">
          <span class="page-title-1depth-text">{{ $t('da.topology_threatStatus') }}</span>
        </div>
        <!-- 타이틀 끝 -->
      </div>
      <div class="contents-row">

        <!-- 컨텐츠 패널 시작 -->
        <div class="portlet">
          <div class="contents-group">
            <div class="contents-row">
                <!-- 테이블 시작 -->
                <table v-if="isShow"
                       class="bs-table table-box-type">

                  <colgroup>
                    <col width="auto" v-for="key in summaryEventData"/>
                  </colgroup>

                  <thead>
                    <tr>
                      <th v-for="(item, key) in summaryEventData">
                        <q-checkbox v-model="item.checked"
                                    :label="item.label"
                                    @input="checkEventLevelFilter(item, key)"
                                    class="bs bs-q-checkbox bs-q-checkbox-default" />
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td v-for="(item, key) in summaryEventData"
                          :style="getLevelStyle(item.level)"
                          class="table-cell-align-center">
                        {{item.data}}
                      </td>
                    </tr>
                  </tbody>

                </table>
                <!-- 테이블 끝 -->
            </div>
          </div>

          <!-- 컨텐츠 분할 시작 -->
          <div class="contents-clearfix"></div>
          <!-- 컨텐츠 분할 끝 -->


          <!-- 텝 1뎁스 시작 -->
          <q-tabs inverted class="bs bs-q-tabs bs-q-tabs-default bs-q-tabs-border-none"
                  v-model="selectedTab"
                  :beforeTabChange="onChangeEventTab"
                  @input="getEventData">

            <q-tab slot="title" name="tab-1"
                   :label="$t('da.widgetSystemEvent')"
                   :disable="selectedTab !== 'tab-1' && waitProcess > 0"
            />
            <q-tab slot="title" name="tab-2"
                   :label="$t('da.eventLogCurrent24h')"
                   :disable="selectedTab !== 'tab-2' && waitProcess > 0"
            />

            <q-tab-pane name="tab-1" style="height:200px;">
              <event-grid slim
                          :tableData="eventData"
                          :tableColumn="tableColumn"
                          :height="175"
                          :virtualScrolling="true"
                          :is-popup="isOpen"
              />
            </q-tab-pane>

            <q-tab-pane name="tab-2" style="height:200px;">
              <event-grid slim
                          :tableData="eventData24"
                          :totalDataCount="eventData24.length || 0"
                          :tableColumn="tableColumn"
                          :pageSize="pageSize"
                          :paging="true"
                          :showPagination="true"
                          :height="200"
                          :is-popup="isOpen"
              />
            </q-tab-pane>

          </q-tabs>
          <!-- 텝 1뎁스 끝 -->

        </div>
        <!-- 컨텐츠 패널 끝 -->

      </div>
    </div>
    <!-- End: [이벤트 현황] 컨텐츠 끝 -->

  </layout-modal>
</template>

<script>
  import LayoutModal from '~/components/popUp/LayoutModalPopUp'
  import EventGrid from '~/components/grids/eventGrid'

  import { getColorLuminance } from '~/utils/charts'
  import { sortCharNum } from '~/utils/sort'

  import { createNamespacedHelpers } from 'vuex'
  const { mapState, mapActions } = createNamespacedHelpers('dashboard/widgetDetail')

  export default {
    name: 'DeviceStatusSummaryPopup',
    components: {
      LayoutModal,
      EventGrid
    },
    // props: {
    //   node: {
    //     type: Object,
    //     default: {
    //
    //     }
    //   }
    // },
    data () {
      return {
        node: {},
        titleName: this.$t('da.equipmentStatusSummary'),
        eventData: [],
        eventData24: [],
        eventDataCnt: 0,
        isShow: false, // 팝업 오픈 시, 칼럼 리사이징 보정용
        risk: 1,
        summaryEventData: {
          total: {
            label: 'Total',
            level: 0,
            checked: true,
            data: 0
          },
          critical: {
            label: 'Critical',
            level: 5,
            checked: true,
            data: 0
          },
          high: {
            label: 'High',
            level: 4,
            checked: true,
            data: 0
          },
          medium: {
            label: 'Medium',
            level: 3,
            checked: true,
            data: 0
          },
          low: {
            label: 'Low',
            level: 2,
            checked: true,
            data: 0
          },
          info: {
            label: 'Info',
            level: 1,
            checked: true,
            data: 0
          }
        },
        selectedTab: 'tab-1',
        pageSize: 10,
        waitProcess: 0,
        isOpen: false
      }
    },
    computed: {
      ...mapState([
        'detailDeviceInfo',
        'eventLevelInfo',
        'detailEventLogData',
        'detailEventLogData24',
        'detailEventLogCnt'
      ]),
      pageMax () {
        const maxPg = this.totalDataCount === 0 ? 1 : Math.ceil(this.totalDataCount / this.pageSize)
        return maxPg
      },
      tableColumn () {
        return [
          {
            name: 'event_level_name',
            field: 'event_level_name',
            align: 'center',
            label: this.$t('cmn.level'),
            width: 60,
            custom: { type: 'eventLevel' },
            tooltip: _.noop(),
            sorter: (data1, data2, item1, item2) => {
              try {
                return sortCharNum(item1.event_level_type, item2.event_level_type)
              } catch (e) {
                return 0
              }
            }
          },
          {
            name: 'event_log_dt',
            field: 'event_log_dt',
            align: 'center',
            label: this.$t('cmn.time')
          },
          {
            name: 'event_type_name',
            field: 'event_type_name',
            align: 'center',
            label: this.$t('lr.log_dataTable_event')
          },
          {
            name: 'event_name',
            field: 'event_name',
            align: 'center',
            label: this.$t('lr.log_dataTable_case')
          },
          {
            name: 'message',
            field: 'message',
            align: 'left',
            label: this.$t('cmn.msg'),
            width: 200
          }
          // TODO: 추후 대응 버튼 추가
          // {
          //   name: 'etc',
          //   align: 'center',
          //   title: this.$t('cmn.confrontation'),
          //   width: 30,
          //   type: 'quasar',
          //   itemTemplate: (value, item) => {
          //     // TODO: 추후 해당 row 값에서 타입 값을 통한 관련 페이지로 이동하는 구문 필요
          //     if (item['event_level_type'] > 0) {
          //       return {
          //         template: 'q-btn',
          //         // data: {
          //         //   color: 'dark',
          //         //   flat: true,
          //         //   size: 'xs',
          //         //   align: 'center',
          //         //   // color: 'primary',
          //         //   // outline: 'outline',
          //         //   // class: 'bs bs-q-btn-xs',
          //         //   // iconClass: 'bs-q-btn-icon-add-xs'
          //         //   icon: 'open_in_new',
          //         //   style: 'bs bs-q-btn-xs bs-q-btn-flat-type'
          //         //   // iconClass: 'ps-icon ps-icon-opneNewWindow'
          //         // },
          //         data: {
          //           toolTip: this.$t('cmn.confrontation'),
          //           flat: true,
          //           align: 'center',
          //           color: 'dark',
          //           outline: 'outline',
          //           class: 'bs bs-q-btn-sm bs-q-btn-flat-type',
          //           // iconClass: 'bs-q-btn-icon bs-q-btn-icon-search'
          //           iconClass: 'ps-icon ps-icon-opneNewWindow'
          //         },
          //         methods: {
          //           click: this.onClick
          //         }
          //       }
          //     }
          //   }
          // }
        ]
      },
      nodeHierarchyLabel () {
        try {
          let res = ''
          _.each(this.node.hierarchy, item => {
            res += `${item.label} > `
          })
          res += this.node.name
          return res
        } catch (e) {
          return this.$t('dash.topology_thisDevice')
        }
      }
    },
    methods: {
      ...mapActions([
        'getDeviceDetail',
        'getEventLevelData',
        'getDeviceEventLog',
        'getDeviceEventLog24',
        'getDeviceEventLogCnt'
      ]),
      initStore () {
        this.node = {}
        this.eventData = []
        this.risk = 1
        this.selectedTab = 'tab-1'
      },
      async show (node) {
        // 초기화
        this.initStore()

        this.node = node
        const deviceId = parseInt(this.node.id)

        if (typeof this.node.event_level !== 'undefined') {
          this.risk = this.node.event_level
        } else {
          this.risk = 1
        }

        await this.getEventLevelData()
        await this.getDeviceDetail(deviceId)

        // summary init
        this.initSummaryData()

        await this.getEventData()

        this.isShow = true
        this.$refs.deviceSumaryModal.show()
      },
      async getEventData (pagePost = 1) {
        // summary init
        this.waitProcess = 1
        this.$loader.show()
        try {
          await this.initSummaryData()

          const deviceIdList = typeof this.node.id !== 'undefined' ? [parseInt(this.node.id)] : []
          if (this.selectedTab === 'tab-1') {
            // 미복구 이벤트
            await this.getDeviceEventLog({deviceIdList})
          } else {
            // 이벤트 로그 (최근 24시간)
            // await this.getDeviceEventLogCnt({ deviceIdList })
            await this.getDeviceEventLog24({deviceIdList})
          }

          this.getFilteredEventLogData(true)
          this.waitProcess = 0
          this.$loader.hide()
        } catch (e) {
          this.waitProcess = 0
          this.$loader.hide()
        }
      },
      onChangeEventTab () {
        if (this.waitProcess > 0) {
          this.$q.notify({
            icon: 'warning',
            color: 'red-15',
            message: this.$t('msg.deviceStatus_alert_BlockTabChange'),
            position: 'top'
          })

          return false
        }

        return true
      },
      hide () {
        this.isShow = false
        this.waitProcess = 0
        this.$refs.deviceSumaryModal.hide()
        this.$emit('hide')
      },
      onConfirm () {
        this.$refs.deviceSumaryModal.hide()
        this.$emit('hide')
      },
      onCancel () {
        this.$refs.deviceSumaryModal.hide()
        this.$emit('hide')
      },
      onClick (v) {
        // this.evt = v
        // let item = v.item
        // return `${item.age}, ${item.name}`
      },
      getLevelStyle (level) {
        if (level >= 1 && level <= 5) {
          const index = level - 1

          if (this.eventLevelInfo.length > 0) {
            const background = this.eventLevelInfo[index].event_level_color,
              color = getColorLuminance(background)

            return {
              background,
              color
            }
          }
        }
      },
      initSummaryData () {
        const checkKeys = Object.keys(this.summaryEventData)
        checkKeys.forEach(key => {
          this.summaryEventData[key].checked = true
          this.summaryEventData[key].data = 0
        })
      },
      checkEventLevelFilter (item, key) {
        const checkKeys = Object.keys(this.summaryEventData)

        if (key === 'total') {
          if (this.summaryEventData.total.checked) {
            checkKeys.forEach(key => {
              this.summaryEventData[key].checked = true
            })
          } else {
            checkKeys.forEach(key => {
              this.summaryEventData[key].checked = false
            })
          }
        } else {
          this.summaryEventData.total.checked = checkKeys.every(key => {
            if (key !== 'total') {
              return this.summaryEventData[key].checked
            } else {
              return true
            }
          })
        }

        this.getFilteredEventLogData()
      },
      getFilteredEventLogData (init = false) {
        const checkKeys = Object.keys(this.summaryEventData)
        let res = []

        if (this.selectedTab === 'tab-1') {
          // 미복구 이벤트
          res = this.detailEventLogData.filter((row, idx) => {
            const key = row.event_level_name.toLowerCase()
            if (checkKeys.indexOf(key) !== -1) {
              if (init) {
                this.summaryEventData[key].data++
                this.summaryEventData.total.data++
              }
              return this.summaryEventData[key].checked
            } else {
              return false
            }
          })
          this.eventData = res
        } else {
          // 이벤트 로그 (최근 24시간)
          res = this.detailEventLogData24.filter((row, idx) => {
            const key = row.event_level_name.toLowerCase()
            if (checkKeys.indexOf(key) !== -1) {
              if (init) {
                this.summaryEventData[key].data++
                this.summaryEventData.total.data++
              }
              return this.summaryEventData[key].checked
            } else {
              return false
            }
          })
          this.eventData24 = res
        }
      },
      calcHierarchyItemPadding (idx, last = false) {
        try {
          let res = {}, paddingTop = 0
          if (!last) {
            if (typeof idx === 'number') {
              paddingTop = 10 + (10 * idx)
            }
          } else {
            paddingTop = 10 + (10 * _.size(this.node.hierarchy)) - 5
          }

          if (paddingTop > 0) {
            res = {
              paddingTop: `${paddingTop}px`
            }
          }
          return res
        } catch (e) {
          return {}
        }
      }
    },
    mounted () {}
  }
</script>

<style scoped>
  .status-level-area {
    border: 1px solid #c4d8f1;
    border-radius: 3px;
    height: 100%;
  }
  .status-level-title-wrapper {
    width: 100%;
    border-bottom: 1px solid #c4d8f1;
    background-color: #B9CCE4;
  }
  .status-level-wrapper {
    width: 100%;
    height: 100px;
    display: table;
  }
  .status-level-title {
    font-size: 10pt;
    font-weight: bold;
  }
  .status-level-text {
    position: relative;
    font-size: 18pt;
    font-weight: 900;
    vertical-align: middle;
    align: center;
    display: table-cell;
    width: 100%;
    margin: auto;
    z-index: 2;
  }
  .status-level-icon {
    position: absolute;
    margin: auto;
    top: 0; left: 0; bottom: 0; right: 0;
    display: table;
    height: auto;
    width: 100%;
    align: center;
    z-index: 1;
    font-family: 'Material Icons';
  }
  .status-level-icon i {
    font-size: 80pt;
    color: rgba(194, 194, 194, 0.5);
  }
  .status-circle {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    border: 3px solid #ddd;
    /*font: 32px Arial, sans-serif;*/
  }

  .popup-body-hr {
   border-top: 1px solid #ddd;
  }
  .table-cell-align-center {
    text-align: center
  }

  .device-hierarchy-scroll-area {
    overflow: auto;
  }
  .device-hierarchy-scroll-area::-webkit-scrollbar { width: 10px; height: 8px; } /* TAMS */
  .device-hierarchy-scroll-area::-webkit-scrollbar-track { background-color: #e5e5e5; }
  .device-hierarchy-scroll-area::-webkit-scrollbar-thumb {
    background-color: #85acd6;
  }
</style>
